import { createContext, useContext } from 'react';

import type { Webhook, WebhookHistory, WebhookTypes } from 'v2/interfaces/webhook2';

import type IPagination from 'interfaces/IPagination';

interface IWebhookHistoryContext {
  webhook: Webhook;
  listWebhookHistory: WebhookHistory[];
  loading: boolean;
  id: string;
  type: WebhookTypes;
  productId: number;
  pagination: IPagination;
  setPagination: (pagination: IPagination) => void;
  updateList: () => void;
}
export const WebhookHistoryContext = createContext<IWebhookHistoryContext>({} as IWebhookHistoryContext);

export function useWebhookHistoryContext() {
  const context = useContext(WebhookHistoryContext);
  return context;
}

export default WebhookHistoryContext;
